/**
 * Instagram / Facebook içi tarayıcıda tam ekran mesaj denemesi. Sepet şeridi ve WhatsApp seçeneği assets/pg-inapp.js'tedir.
 * Açılışta ve ilk sepete eklemede birer kez tam ekran mesaj gösterir; deneme gruplarını _pg_tarayici sepet özelliğine yazar.
 *
 * Otomatik yönlendirme yoktur: müşteri mesajı okur, düğmeye basınca geçiş denenir.
 * Geçiş yolları (belgelenmemiş, cihazda doğrulanmalı):
 *   Instagram iOS : instagram://extbrowser/  |  Threads iOS : barcelona://extbrowser/
 *   Facebook iOS  : x-safari-https://  (dokunuş gerekir)     |  iOS Chrome  : googlechromes://
 *   Android       : intent:// (Chrome veya varsayılan tarayıcı)
 *   Olmazsa       : ••• > Harici tarayıcıda aç yönergesi ve bağlantı kopyalama
 *
 * Mesajı görenlerin payı SHOW_SHARE ile ayarlanır; kalanı karşılaştırma grubudur. 0 ise mesaj kapalı, yalnızca ölçüm çalışır.
 * ?pg_inapp=auto mesajı gerçek tarayıcıyla gösterir, ?pg_inapp=tani hangi geçiş yolunun çalıştığını gösteren tanı ekranını açar.
 * Önizlemede ?pg_inapp=instagram-ios gibi bir değer taklitle dener.
 */
(() => {
  if (window.__pgInappTam) return;
  window.__pgInappTam = true;

  const SHOW_SHARE = 0.5;
  const ATTR = '_pg_tarayici';
  const root = window.Shopify?.routes?.root || '/';
  const isPreview = window.Shopify?.theme?.role !== 'main';
  const params = new URLSearchParams(location.search);
  const rawTest = params.get('pg_inapp');
  const isDiag = rawTest === 'tani';
  const isAutoTest = rawTest === 'auto';
  const isSim = isPreview && Boolean(rawTest) && !isDiag && !isAutoTest;
  const testParam = isDiag || isAutoTest || isSim ? rawTest : null;

  const store = {
    get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* gizli pencere */ } },
    sget: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* gizli pencere */ } },
  };

  const detect = () => {
    if (isSim) {
      const [app, os] = testParam.split('-');
      return { app, os: os || 'android' };
    }
    const ua = navigator.userAgent;
    let app = null;
    if (/Barcelona/i.test(ua)) app = 'threads';
    else if (/Instagram/i.test(ua)) app = 'instagram';
    else if (/FBAN|FBAV|FB_IAB|FBIOS/i.test(ua)) app = 'facebook';
    return { app, os: /iPhone|iPad|iPod/i.test(ua) ? 'ios' : 'android' };
  };

  const { app, os } = detect();
  const moved = params.get('pg_gecis') === '1';
  if (moved && !app) store.set('pg_gecis', '1');

  let group = store.get('pg_grup');
  if (app && !group) {
    group = Math.random() < SHOW_SHARE ? 'uyari' : 'kontrol';
    store.set('pg_grup', group);
  }
  if (app && !SHOW_SHARE) group = 'kontrol';
  if (app && testParam) group = 'uyari';

  const label = () => {
    if (app) return `${app}-${os}-${group}`;
    return store.get('pg_gecis') ? 'gecis' : 'normal';
  };

  const nativeFetch = window.fetch.bind(window);
  const getCart = async () => {
    const res = await nativeFetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    return res.ok ? res.json() : null;
  };

  let syncing = false;
  const syncAttr = async () => {
    if (syncing || !(SHOW_SHARE > 0 || testParam)) return;
    syncing = true;
    try {
      const cart = await getCart();
      if (cart && cart.item_count > 0 && cart.attributes?.[ATTR] !== label()) {
        await nativeFetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [ATTR]: label() } }),
        });
      }
    } catch (e) {
      /* ölçüm alışverişi etkilememeli */
    } finally {
      syncing = false;
    }
  };

  /* Dışarıda açılacak adres: sepet doluysa ürünleriyle, boşsa bulunulan sayfa */
  const targetUrl = async () => {
    const cart = await getCart().catch(() => null);
    let url;
    if (cart && cart.item_count > 0) {
      const qty = {};
      cart.items.forEach((i) => { qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
      const items = Object.keys(qty).map((id) => `${id}:${qty[id]}`).join(',');
      url = new URL(`${root}cart/${items}`, location.origin);
      url.searchParams.set('storefront', 'true');
      const code = (cart.discount_codes || []).find((d) => d.applicable)?.code;
      if (code) url.searchParams.set('discount', code);
    } else {
      url = new URL(location.href);
      url.searchParams.delete('pg_inapp');
    }
    /* Reklam kimlikleri: assets/pg-inapp.js ilk girişte saklar */
    window.PgAdParams?.addTo(url);
    url.searchParams.set('pg_gecis', '1');
    if (isPreview && window.Shopify?.theme?.id) url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    return url;
  };

  const links = (url) => {
    const full = url.href;
    const rest = `${url.host}${url.pathname}${url.search}`;
    const fallback = `S.browser_fallback_url=${encodeURIComponent(full)}`;
    if (os === 'android') {
      return {
        main: `intent://${rest}#Intent;scheme=https;package=com.android.chrome;${fallback};end`,
        mainLabel: "Chrome'da aç",
        alt: `intent://${rest}#Intent;scheme=https;action=android.intent.action.VIEW;${fallback};end`,
        altLabel: 'Başka tarayıcıda aç',
      };
    }
    const chrome = { alt: `googlechromes://${rest}`, altLabel: "Chrome'da aç" };
    if (app === 'instagram') return { main: `instagram://extbrowser/?url=${encodeURIComponent(full)}`, mainLabel: 'Tarayıcıda aç', ...chrome };
    if (app === 'threads') return { main: `barcelona://extbrowser/?url=${encodeURIComponent(full)}`, mainLabel: 'Tarayıcıda aç', ...chrome };
    return { main: `x-safari-https://${rest}`, mainLabel: "Safari'de aç", ...chrome };
  };

  const css = `
    html.pg-iab-open, html.pg-iab-open body { overflow: hidden !important; }
    .pg-iab { position: fixed; inset: 0; z-index: 2147483000; display: flex; flex-direction: column; align-items: center; overflow-y: auto; -webkit-overflow-scrolling: touch; padding: max(20px, env(safe-area-inset-top)) 20px max(20px, env(safe-area-inset-bottom)); background: #fbf7f1; color: #2b2522; font: 400 15px/1.5 var(--font-body-family, Poppins, sans-serif); }
    .pg-iab[hidden] { display: none; }
    .pg-iab__inner { display: grid; gap: 14px; width: 100%; max-width: 400px; margin: auto 0; }
    .pg-iab__logo { display: block; width: 136px; height: auto; margin: 0 auto; }
    .pg-iab__card { display: grid; gap: 12px; padding: 20px 18px; border: 1px solid #eadfd3; border-radius: 18px; background: #fff; box-shadow: 0 8px 28px rgb(60 30 15 / .07); }
    .pg-iab__badge { display: grid; place-items: center; width: 52px; height: 52px; margin: 0 auto; border-radius: 50%; background: #eaf6ee; color: #1f7a45; }
    .pg-iab__title { margin: 0; font-size: 20px; font-weight: 700; line-height: 1.3; text-align: center; color: #2b2522; }
    .pg-iab__text { margin: 0; font-size: 14.5px; line-height: 1.5; text-align: center; color: #5c534d; }
    .pg-iab__list { display: grid; gap: 8px; margin: 0; padding: 12px 0 0; border-top: 1px solid #f1e9e0; list-style: none; }
    .pg-iab__list li { display: flex; align-items: flex-start; gap: 9px; margin: 0; padding: 0; font-size: 13.5px; line-height: 1.4; color: #3d3531; list-style: none; }
    .pg-iab__list svg { flex: 0 0 auto; margin-top: 1px; color: #1f7a45; }
    html body .pg-iab a.pg-iab__btn, html body .pg-iab button.pg-iab__btn { display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; min-height: 52px !important; height: auto !important; margin: 0; padding: 10px 14px !important; border: 1.5px solid #840b00; border-radius: 14px; background: #fff; color: #840b00 !important; font: 600 15px/1.25 var(--font-body-family, Poppins, sans-serif); text-decoration: none; cursor: pointer; }
    html body .pg-iab a.pg-iab__btn--main { position: sticky; bottom: 8px; z-index: 1; background: #840b00; color: #fff !important; font-size: 16px; box-shadow: 0 6px 18px rgb(120 20 10 / .22); }
    html body .pg-iab p.pg-iab__title { font-weight: 700 !important; color: #2b2522 !important; }
    html body .pg-iab p.pg-iab__text { color: #5c534d !important; }
    @media (max-height: 700px) {
      .pg-iab__badge { display: none; }
      .pg-iab__logo { width: 112px; }
      .pg-iab__card { gap: 10px; padding: 14px; }
      html body .pg-iab p.pg-iab__title { font-size: 18px; }
      html body .pg-iab p.pg-iab__text { font-size: 13.5px; }
    }
    .pg-iab__note { margin: 0; padding: 10px 12px; border-radius: 12px; background: #fff8ec; font-size: 13px; line-height: 1.45; text-align: center; color: #5c534d; }
    html body .pg-iab button.pg-iab__stay { min-height: 44px !important; height: auto !important; margin: 0; padding: 8px !important; border: 0; background: transparent; color: #4a413c !important; font: 500 14.5px/1.3 var(--font-body-family, Poppins, sans-serif); text-decoration: underline; text-underline-offset: 3px; cursor: pointer; }
    .pg-iab__more { border-top: 1px solid #eadfd3; padding-top: 8px; }
    .pg-iab__more summary { min-height: 40px; padding: 9px 0; font-size: 13.5px; font-weight: 500; text-align: center; color: #5c534d; cursor: pointer; }
    .pg-iab__more-body { display: grid; gap: 8px; padding-top: 4px; }
    .pg-iab__help { margin: 0; font-size: 13px; line-height: 1.5; text-align: center; color: #5c534d; }
    html body .pg-iab .pg-iab__more-body .pg-iab__btn { min-height: 46px !important; font-size: 14px; }
    .pg-iab__foot { margin: 0; font-size: 12.5px; line-height: 1.5; text-align: center; color: #6b5f5a; }
    html body .pg-iab .pg-iab__foot a { color: #4a413c !important; font-weight: 600; text-decoration: underline; text-underline-offset: 2px; }
  `;

  const ICON_LOCK = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"/></svg>';
  const ICON_CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>';
  const appName = app === 'facebook' ? 'Facebook' : app === 'threads' ? 'Threads' : 'Instagram';
  const confirmNote = () => {
    if (os === 'android' && app === 'instagram') return 'Instagram "Uygulamamızdan ayrılıyorsun" diye soracak. Bu normaldir, <b>Devam et</b> seçeneğine dokunun.';
    return `${appName} onay sorarsa bu normaldir, <b>devam edin</b>.`;
  };

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      const t = document.createElement('textarea');
      t.value = text;
      document.body.appendChild(t);
      t.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
      t.remove();
      return ok;
    }
  };

  let screen = null;
  let tapped = false;
  const closeScreen = () => {
    if (screen) screen.hidden = true;
    document.documentElement.classList.remove('pg-iab-open');
  };

  const showScreen = async (title, text, openHelp = false) => {
    if (!document.getElementById('pg-iab-css')) {
      const st = document.createElement('style');
      st.id = 'pg-iab-css';
      st.textContent = css;
      document.head.appendChild(st);
    }
    const url = await targetUrl();
    const l = links(url);
    if (screen) screen.remove();
    screen = document.createElement('div');
    screen.className = 'pg-iab';
    screen.setAttribute('role', 'dialog');
    screen.setAttribute('aria-modal', 'true');
    screen.setAttribute('aria-label', title);
    const menu = os === 'ios' ? '•••' : '⋮';
    screen.innerHTML = `
      <div class="pg-iab__inner">
        <img class="pg-iab__logo" alt="" width="400" height="134" hidden>
        <div class="pg-iab__card">
          <div class="pg-iab__badge">${ICON_LOCK}</div>
          <p class="pg-iab__title"></p>
          <p class="pg-iab__text"></p>
          <ul class="pg-iab__list" role="list">
            <li>${ICON_CHECK}<span>Yine <b>palmiyegurme.com</b> açılır, siteden ayrılmazsınız</span></li>
            <li>${ICON_CHECK}<span>Sepetinizdeki ürünler sizinle gelir</span></li>
            <li>${ICON_CHECK}<span>Ödemeniz SSL ile korunur, PayTR altyapısıyla alınır</span></li>
          </ul>
        </div>
        <a class="pg-iab__btn pg-iab__btn--main" data-pg-iab-main></a>
        <p class="pg-iab__note">${confirmNote()}</p>
        <button type="button" class="pg-iab__stay" data-pg-iab-stay>Burada devam et</button>
        <details class="pg-iab__more"${openHelp ? ' open' : ''}>
          <summary>Tarayıcı açılmazsa</summary>
          <div class="pg-iab__more-body">
            <p class="pg-iab__help">Sağ üstteki <b>${menu}</b> menüsünden <b>Harici tarayıcıda aç</b> seçeneğine dokunun ya da aşağıdaki seçenekleri deneyin.</p>
            <a class="pg-iab__btn" data-pg-iab-alt></a>
            <button type="button" class="pg-iab__btn" data-pg-iab-copy>Bağlantıyı kopyala</button>
          </div>
        </details>
        <p class="pg-iab__foot">ETBİS'e kayıtlıdır · Yardım: <a href="tel:08505320756">0850 532 07 56</a></p>
      </div>`;
    const logo = screen.querySelector('.pg-iab__logo');
    const headerLogo = document.querySelector('.smart-header__logo-image');
    if (headerLogo) {
      logo.src = headerLogo.currentSrc || headerLogo.src;
      logo.alt = 'Palmiye Gurme';
      logo.hidden = false;
    }
    screen.querySelector('.pg-iab__title').textContent = title;
    screen.querySelector('.pg-iab__text').textContent = text;
    const main = screen.querySelector('[data-pg-iab-main]');
    main.href = l.main;
    main.textContent = l.mainLabel;
    const alt = screen.querySelector('[data-pg-iab-alt]');
    alt.href = l.alt;
    alt.textContent = l.altLabel;
    [main, alt].forEach((a) => a.addEventListener('click', () => { tapped = true; }));
    const copyBtn = screen.querySelector('[data-pg-iab-copy]');
    copyBtn.onclick = async () => {
      const ok = await copy(url.href);
      copyBtn.textContent = ok ? 'Kopyalandı' : 'Kopyalanamadı';
    };
    screen.querySelector('[data-pg-iab-stay]').onclick = closeScreen;
    document.body.appendChild(screen);
    document.documentElement.classList.add('pg-iab-open');
    return l;
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') return;
    if (!screen || screen.hidden || !tapped) return;
    const t = screen.querySelector('.pg-iab__title');
    if (t) t.textContent = 'Tarayıcınız açıldıysa oradan devam edebilirsiniz';
  });

  const showOpening = async () => {
    if (store.sget('pg_iab_acilis') && !testParam) return;
    store.sset('pg_iab_acilis', '1');
    await showScreen('Alışverişinize güvenle devam edin', `${appName} içinde kart onayı yarıda kalabiliyor. Sitemizi telefonunuzun tarayıcısında açarak ödemenizi daha rahat tamamlayabilirsiniz.`);
  };

  const showAfterAdd = async () => {
    if (store.sget('pg_iab_sepet')) return;
    store.sset('pg_iab_sepet', '1');
    await showScreen('Ödemenizi güvenle tamamlayın', `${appName} içinde kart onayı yarıda kalabiliyor. Sepetinizi telefonunuzun tarayıcısında açıp ödemeyi orada tamamlayabilirsiniz.`);
  };

  let timer = null;
  const onCartChange = (added) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(async () => {
      await syncAttr();
      if (added && app && group === 'uyari') showAfterAdd();
    }, 300);
  };

  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const p = nativeFetch(...args);
    if (/\/cart\/add(\.js)?/.test(url)) p.then(() => onCartChange(true), () => {});
    else if (/\/cart\/(change|update)(\.js)?/.test(url)) p.then(() => onCartChange(false), () => {});
    return p;
  };
  document.addEventListener('cart:update', () => onCartChange(false));

  /* Tanı ekranı: yalnızca önizlemede. Her yolu ayrı dener, sonucu düğmeye yazar. */
  const showDiag = () => {
    const url = new URL(location.origin + location.pathname);
    url.searchParams.set('pg_gecis', '1');
    if (isPreview && window.Shopify?.theme?.id) url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    const full = url.href;
    const enc = encodeURIComponent(full);
    const rest = `${url.host}${url.pathname}${url.search}`;
    const ways = [
      ['Instagram extbrowser', `instagram://extbrowser/?url=${enc}`],
      ['Threads extbrowser', `barcelona://extbrowser/?url=${enc}`],
      ['Safari (x-safari-https)', `x-safari-https://${rest}`],
      ['iOS Chrome (googlechromes)', `googlechromes://${rest}`],
      ['Android Chrome (intent)', `intent://${rest}#Intent;scheme=https;package=com.android.chrome;end`],
      ['Android varsayılan (intent)', `intent://${rest}#Intent;scheme=https;action=android.intent.action.VIEW;end`],
      ['Android Chrome (googlechrome)', `googlechrome://navigate?url=${enc}`],
    ];
    const el = document.createElement('div');
    el.style.cssText = 'position:fixed;inset:0;z-index:2147483000;overflow-y:auto;padding:16px 16px 90px;background:#fff;color:#222;font:14px/1.4 system-ui,sans-serif';
    const head = document.createElement('p');
    head.style.cssText = 'margin:0 0 10px;font-weight:700';
    head.textContent = `Tanı: uygulama=${app || 'yok'} sistem=${os}`;
    const ua = document.createElement('p');
    ua.style.cssText = 'margin:0 0 12px;font-size:11px;color:#666;word-break:break-all';
    ua.textContent = navigator.userAgent;
    el.append(head, ua);
    ways.forEach(([name, href]) => {
      const a = document.createElement('a');
      a.href = href;
      a.textContent = name;
      a.style.cssText = 'display:block;margin:0 0 8px;padding:13px;border:1px solid #840b00;border-radius:10px;color:#840b00;font-weight:600;text-decoration:none';
      a.addEventListener('click', () => {
        let left = false;
        const mark = () => { if (document.visibilityState === 'hidden') left = true; };
        document.addEventListener('visibilitychange', mark);
        window.addEventListener('pagehide', () => { left = true; }, { once: true });
        setTimeout(() => {
          document.removeEventListener('visibilitychange', mark);
          a.textContent = `${name}: ${left ? 'UYGULAMADAN ÇIKTI' : 'ÇIKMADI'}`;
          a.style.background = left ? '#e6f4ea' : '#fdecea';
        }, 2500);
      });
      el.appendChild(a);
    });
    document.body.appendChild(el);
  };

  syncAttr();

  if (isDiag) {
    showDiag();
  } else if (app && group === 'uyari') {
    if (moved) {
      /* Geçiş denendi ama hâlâ uygulama içindeyiz: seçenekler görünür */
      showScreen('Tarayıcı açılamadı', 'Sorun değil. Aşağıdaki seçeneklerle yeniden deneyebilir ya da alışverişinize burada devam edebilirsiniz.', true);
    } else {
      showOpening();
    }
  }
})();
